<template>
  <div>
    <DefaultPage id="leadership">
      <HeroTextSection id="leadershipHero"
                       text="“The growth and development of people is the highest calling of leadership.”"
                       subtext="Harvey S. Firestone"
                       video-id="397238558"
                       image-name="hero-leadership.jpg"
                       data-aos="fade"/>
      <VisualDataSection id="board-of-directors"
                      title="Our Board of Directors"
                      subcolor="#93c741"
                      style="position:relative;top:-50px;"
      >
        <div class="grid-container">
          <div class="grid-x grid-margin-x grid-padding-x">
            <div class="cell medium-4">
              <div class="section">
                <h4>Hugh Francis, III, MD</h4>
                <h6>CHAIR OF THE BOARD</h6>
                <p>General and Vascular Surgery</p>
                <p>Memphis Surgery Associates PC</p>
                <p>Memphis, Tennessee</p>
                <p>Director Since 1997</p>
              </div>
              <div class="section">
                <h4>John O. Lytle, MD</h4>
                <h6>VICE CHAIR OF THE BOARD</h6>
                <p>Orthopaedic Surgery</p>
                <p>South Arkansas Orthopaedic Center</p>
                <p>Pine Bluff, Arkansas</p>
                <p>Director Since 2006</p>
              </div>
              <div class="section">
                <h4>Katrina M. Hood, MD</h4>
                <h6>SECRETARY OF SVMIC</h6>
                <p>Pediatrics</p>
                <p>Pediatric and Adolescent Associates PSC</p>
                <p>Lexington, Kentucky</p>
                <p>Director Since 2009</p>
              </div>
              <div class="section">
                <h4>Matthew L. Perkins, MD</h4>
                <h6>TREASURER OF SVMIC</h6>
                <p>Internal Medicine and Pediatrics</p>
                <p>Tennessee Medicine and Pediatrics PC</p>
                <p>Smyrna, Tennessee</p>
                <p>Director Since 2008</p>
              </div>
              <div class="section">
                <h4>Robert J. Berkompas, MD</h4>
                <p>Internal Medicine</p>
                <p>Saint Thomas Medical Group</p>
                <p>Nashville, Tennessee</p>
                <p>Director Since 2010</p>
              </div>
              <div class="section">
                <h4>Melanie B. Blake, MD</h4>
                <p>Internal Medicine</p>
                <p>CHI Memorial</p>
                <p>Chattanooga, Tennessee</p>
                <p>Director Since 2018</p>
              </div>
            </div>
            <div class="cell medium-4">
              <div class="section">
                <h4>Chad T. Couch, MD</h4>
                <p>Urology</p>
                <p>Vice President,</p>
                <p>Chief Medical Officer</p>
                <p>Ballad Health - Northeast Market</p>
                <p>Bristol, Tennessee</p>
                <p>Director Since 2008</p>
              </div>
              <div class="section">
                <h4>Wayne A. Hudec, MD</h4>
                <p>General Surgery</p>
                <p>Ozark Surgical Associates</p>
                <p>Fayetteville, Arkansas</p>
                <p>Director Since 2009</p>
              </div>
              <div class="section">
                <h4>William I. Mariencheck, Jr., MD</h4>
                <p>Pulmonary and Critical Care Medicine</p>
                <p>Wake Forest University Health Sciences</p>
                <p>Winston-Salem, NC</p>
                <p>Director Since 2012</p>
              </div>
              <div class="section">
                <h4>Raymond S. Martin, III, MD</h4>
                <p>General and Vascular Surgery</p>
                <p>Physician Director of Surgical Services</p>
                <p>Saint Thomas Health</p>
                <p>Nashville, Tennessee</p>
                <p>Director Since 1994</p>
              </div>
              <div class="section">
                <h4>Michael A. McAdoo, MD</h4>
                <p>Family Medicine</p>
                <p>Milan Medical Center PC</p>
                <p>Milan, Tennessee</p>
                <p>Director Since 2002</p>
              </div>
            </div>
            <div class="cell medium-4">
              <div class="section">
                <h4>Paul C. McNabb, II, MD</h4>
                <p>Internal Medicine/Infectious Disease</p>
                <p>Saint Thomas Health</p>
                <p>Nashville, Tennessee</p>
                <p>Director Since 1996</p>
              </div>
              <div class="section">
                <h4>Russell E. Miller, CAE</h4>
                <p>Chief Executive Officer</p>
                <p>Tennessee Medical Association</p>
                <p>Nashville, Tennessee</p>
                <p>Director Since 2013</p>
              </div>
              <div class="section">
                <h4>John H. Mize, FCAS, MAAA</h4>
                <p>President and Chief Executive Officer</p>
                <p>SVMIC</p>
                <p>Brentwood, Tennessee</p>
                <p>Director Since 2013</p>
              </div>
              <div class="section">
                <h4>Elise E. Schriver, MD</h4>
                <p>Pulmonary and Critical Care Medicine</p>
                <p>University Pulmonary and Critical Care</p>
                <p>Knoxville, Tennessee</p>
                <p>Director Since 2002</p>
              </div>
              <div class="section">
                <h4>Jane M. Sneed, MD</h4>
                <p>Pediatrics</p>
                <p>The Children’s Clinic</p>
                <p>Jonesboro, Arkansas</p>
                <p>Director Since 2013</p>
              </div>
              <div class="section">
                <h4>Lisa J. Young, MD</h4>
                <p>Invasive Cardiology</p>
                <p>Sutherland Cardiology Clinic, Inc.</p>
                <p>Germantown, Tennessee</p>
                <p>Director Since 2013</p>
              </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
      <VisualDataSection id="officers"
                      title="Our Officers">
        <div class="grid-container">
          <div class="grid-x grid-margin-x grid-padding-x">
            <div class="cell medium-4">
              <div class="section">
                <h4>Hugh Francis, III, MD</h4>
                <h6>CHAIR OF THE BOARD</h6>
              </div>
              <div class="section">
                <h4>John O. Lytle, MD</h4>
                <h6>VICE CHAIR OF THE BOARD</h6>
              </div>
              <div class="section">
                <h4>Katrina M. Hood, MD</h4>
                <h6>SECRETARY OF SVMIC</h6>
              </div>
              <div class="section">
                <h4>Matthew L. Perkins, MD</h4>
                <h6>TREASURER OF SVMIC</h6>
              </div>
              <div class="section">
                <h4>John H. Mize, FCAS, MAAA</h4>
                <h6>PRESIDENT AND CHIEF EXECUTIVE OFFICER</h6>
              </div>
              <div class="section">
                <h4>Michael A. Ricciardelli</h4>
                <h6>CHIEF FINANCIAL OFFICER</h6>
              </div>
              <div class="section">
                <h4>Stephen A. Dickens, JD, FACMPE</h4>
                <h6>VICE PRESIDENT, MEDICAL PRACTICE SERVICES</h6>
              </div>
              <div class="section">
                <h4>Sherie L. Edwards, JD, MBA</h4>
                <h6>VICE PRESIDENT, CORPORATE AND LEGAL</h6>
              </div>
              <div class="section">
                <h4>Raymond M. Meador, Jr., MBA</h4>
                <h6>VICE PRESIDENT, BUSINESS DEVELOPMENT</h6>
              </div>
              <div class="section">
                <h4>Kenneth W. Rucker, JD</h4>
                <h6>VICE PRESIDENT, CLAIMS</h6>
              </div>
            </div>
            <div class="cell medium-4">
              <div class="section">
                <h4>D. Mart Sesler</h4>
                <h6>VICE PRESIDENT, INFORMATION SYSTEMS</h6>
              </div>
              <div class="section">
                <h4>Charmy M. Shrode, CIC</h4>
                <h6>VICE PRESIDENT, UNDERWRITING</h6>
              </div>
              <div class="section">
                <h4>Rochelle E. Weatherly, JD</h4>
                <h6>VICE PRESIDENT, RISK EDUCATION AND EVALUATION SERVICES</h6>
              </div>
              <div class="section">
                <h4>Jackie P. Boswell, MBA, FACMPE</h4>
                <h6>ASSISTANT VICE PRESIDENT, MEDICAL PRACTICE SERVICES</h6>
              </div>
              <div class="section">
                <h4>Kathy Cartwright, BSN, RN, CPHQ, LNCC</h4>
                <h6>ASSISTANT VICE PRESIDENT, RISK ANALYTICS</h6>
              </div>
              <div class="section">
                <h4>Susan Decareaux, CPCU, CISR, RPLU</h4>
                <h6>ASSISTANT VICE PRESIDENT, UNDERWRITING, PRICING AND RISK ANALYSIS</h6>
              </div>
              <div class="section">
                <h4>Dan Himmelberg, JD</h4>
                <h6>ASSISTANT VICE PRESIDENT, CLAIMS</h6>
              </div>
              <div class="section">
                <h4>Julie Loomis, RN, JD</h4>
                <h6>ASSISTANT VICE PRESIDENT, RISK EDUCATION AND EVALUATION SERVICES</h6>
              </div>
              <div class="section">
                <h4>Andy Meyers</h4>
                <h6>ASSISTANT VICE PRESIDENT, INFORMATION SYSTEMS</h6>
              </div>
            </div>
            <div class="cell medium-4">
              <div class="section">
                <h4>Judy Musgrove</h4>
                <h6>ASSISTANT VICE PRESIDENT, MARKETING AND COMMUNICATIONS</h6>
              </div>
              <div class="section">
                <h4>Deborah D. Rose, RN, LNC</h4>
                <h6>ASSISTANT VICE PRESIDENT, MEDICAL INFORMATION SERVICES</h6>
              </div>
              <div class="section">
                <h4>Judy Vinson, RN, BSN, CPHQ, LNCC</h4>
                <h6>ASSISTANT VICE PRESIDENT, RISK EDUCATION AND EVALUATION SERVICES</h6>
              </div>
              <div class="section">
                <h4>Alisa S. Wamble, JD</h4>
                <h6>ASSISTANT VICE PRESIDENT, CLAIMS</h6>
              </div>
              <div class="section">
                <h4>Tom Werner, FCAS, MAAA</h4>
                <h6>ASSISTANT VICE PRESIDENT, ACTUARIAL AND BUSINESS ANALYTICS</h6>
              </div>
              <div class="section">
                <h4>Susan L. Bennett</h4>
                <h6>DIRECTOR OF FINANCE AND ASSISTANT CORPORATE SECRETARY</h6>
              </div>
              <div class="section">
                <h4>Patrick McBride, CPA</h4>
                <h6>DIRECTOR OF FINANCIAL REPORTING AND ASSISTANT CORPORATE SECRETARY</h6>
              </div>
              <div class="section">
                <h4>Amy J. Banniza, MBA</h4>
                <h6>CONTROLLER</h6>
              </div>
              <div class="section">
                <h4>Renee A. Lewis</h4>
                <h6>ASSISTANT CORPORATE SECRETARY AND ADMINISTRATOR, CLAIMS</h6>
              </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
      <VisualDataSection id="committees"
                      title="Committees of the Board">
        <div class="grid-container">
          <div class="grid-x grid-margin-x grid-padding-x">
            <div class="cell medium-4">
              <div class="section">
                <h4>Arkansas Advisory Committee</h4>
                <p>Wayne A. Hudec, MD, Chair</p>
                <p>J. Gregory Elders, MD</p>
                <p>E. Scott Ferguson, MD</p>
                <p>Keitha D. Holland, MD</p>
                <p>John O. Lytle, MD</p>
                <p>David M. Mego, MD</p>
                <p>Juan C. Roman, MD</p>
                <p>Jane M. Sneed, MD</p>
                <p>Dennis B. Yelvington, MD</p>
              </div>
              <div class="section">
                <h4>Audit Committee</h4>
                <p>Robert J. Berkompas, MD, Chair</p>
                <p>Katrina M. Hood, MD</p>
                <p>Michael A. McAdoo, MD</p>
                <p>David A. Curbo, CPA (Non-member Consultant)</p>
              </div>
              <div class="section">
                <h4>Budget Committee</h4>
                <p>Raymond S. Martin, III, MD, Chair</p>
                <p>Hugh Francis, III, MD</p>
                <p>John O. Lytle, MD</p>
                <p>William I. Mariencheck, Jr., MD</p>
                <p>Michael A. McAdoo, MD</p>
                <p>Paul C. McNabb, II, MD</p>
                <p>Matthew L. Perkins, MD</p>
                <p>Elise E. Schriver, MD</p>
              </div>
              <div class="section">
                <h4>Claims Management Core Committee</h4>
                <p>Raymond S. Martin, III, MD, Chair</p>
                <p>Hugh Francis, III, MD</p>
                <p>John O. Lytle, MD</p>
                <p>Paul C. McNabb, II, MD</p>
                <p>Elise E. Schriver, MD</p>
              </div>
            </div>
            <div class="cell medium-4">
              <div class="section">
                <h4>Claims Management Committee Consultants</h4>
                <p>R. Louis Adams, MD</p>
                <p>Neal S. Beckford, MD</p>
                <p>Jon S. Cohen, MD</p>
                <p>William H. Edwards, Jr., MD</p>
                <p>Daniel S. Ely, MD</p>
                <p>J. Chris Fleming, MD</p>
                <p>Keith L. Goldberg, MD</p>
                <p>Brian M. Jerkins, MD</p>
                <p>J. Louis Manning, MD</p>
                <p>Robert H. Miller, II, MD</p>
                <p>J. Philip Moyers, MD</p>
                <p>Alan P. Mullins, MD</p>
                <p>Frank J. Murabito, MD</p>
                <p>David J. Soll, MD</p>
                <p>Jane M. Thomas, MD</p>
              </div>
              <div class="section">
                <h4>Compensation Committee</h4>
                <p>William I. Mariencheck, Jr., MD, Chair</p>
                <p>Hugh Francis, III, MD</p>
                <p>John O. Lytle, MD</p>
                <p>Raymond S. Martin, III, MD</p>
                <p>Michael A. McAdoo, MD</p>
                <p>Paul C. McNabb, II, MD</p>
                <p>Matthew L. Perkins, MD</p>
                <p>Elise E. Schriver, MD</p>
                <p>Kye Hudson (Non-member Consultant)</p>
              </div>
              <div class="section">
                <h4>Executive Committee</h4>
                <p>John O. Lytle, MD, Chair</p>
                <p>Chad T. Couch, MD</p>
                <p>Hugh Francis, III, MD</p>
                <p>Katrina M. Hood, MD</p>
                <p>Raymond S. Martin, III, MD</p>
                <p>John H. Mize, FCAS, MAAA</p>
                <p>Matthew L. Perkins, MD</p>
                <p>Elise E. Schriver, MD</p>
              </div>
              <div class="section">
                <h4>Investment Committee</h4>
                <p>Matthew L. Perkins, MD, Chair</p>
                <p>Hugh Francis, III, MD</p>
                <p>John O. Lytle, MD</p>
                <p>William I. Mariencheck, Jr., MD</p>
                <p>Raymond S. Martin, III, MD</p>
                <p>Michael A. McAdoo, MD</p>
                <p>Paul C. McNabb, II, MD</p>
                <p>Elise E. Schriver, MD</p>
              </div>
            </div>
            <div class="cell medium-4">
              <div class="section">
                <h4>Risk Management Committee</h4>
                <p>Elise E. Schriver, MD, Chair</p>
                <p>J. Michelle Allmon, MD</p>
                <p>Michael S. Dolan, MD</p>
                <p>Daniel S. Ely, MD</p>
                <p>JimBob Faulk, MD</p>
                <p>Scott R. Fowler, MD</p>
                <p>Hugh Francis, III, MD</p>
                <p>Katrina M. Hood, MD</p>
                <p>Charles S. Joels, MD</p>
                <p>John O. Lytle, MD</p>
                <p>Paul C. McNabb, II, MD</p>
                <p>Douglas O. Olsen, MD</p>
                <p>Antwan D. Robinson, MD</p>
                <p>Matthew P. Willis, MD</p>
              </div>
              <div class="section">
                <h4>Succession Planning Committee</h4>
                <p>Hugh Francis, III, MD, Chair</p>
                <p>John O. Lytle, MD</p>
                <p>Paul C. McNabb, II, MD</p>
                <p>John H. Mize, FCAS, MAAA</p>
                <p>Michael A. Ricciardelli, CPA</p>
                <p>Elise E. Schriver, MD</p>
                <p>Kye Hudson (Non-member Consultant)</p>
              </div>
              <div class="section">
                <h4>Underwriting Committee</h4>
                <p>Chad T. Couch, MD, Chair</p>
                <p>Brady W. Allen, MD</p>
                <p>Robert J. Berkompas, MD</p>
                <p>Mark E. Bigler, MD</p>
                <p>Ravi D. Chauhan, MD</p>
                <p>Anthony T. Everhart, MD</p>
                <p>Hugh Francis, III, MD</p>
                <p>Benjamin L. Huff, MD</p>
                <p>Robert C. Hughes, MD</p>
                <p>Shauna Lorenzo-Rivera, MD</p>
                <p>John O. Lytle, MD</p>
                <p>William I. Mariencheck, Jr., MD</p>
                <p>Paul C. McNabb, II, MD</p>
                <p>Ryan D. Mire, MD</p>
                <p>Craig A. Myers, MD</p>
                <p>Matthew L. Perkins, MD</p>
                <p>Jason A. Weaver, MD</p>
                <p>Lisa J. Young, MD</p>
              </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
    </DefaultPage>
  </div>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import VisualDataSection from '@/components/section/VisualDataSection';
import HeroTextSection from '@/components/section/HeroTextSection';

export default {
  name: 'Leadership',
  components: {
    VisualDataSection,
    DefaultPage,
    HeroTextSection
  }
};
</script>
